"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    justifyContent: "center"
  }
}));
const DetectLink = item => {
  const {
    addition,
    id,
    reference,
    text,
    title
  } = item;
  if (addition === "_blank") {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: text !== null && text !== void 0 ? text : "/",
      key: id,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
  } else if (addition === "mailto") {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: text ? "mailto:" + text : "/",
      key: id
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
  } else {
    var _reference$pageName;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: (_reference$pageName = reference === null || reference === void 0 ? void 0 : reference.pageName) !== null && _reference$pageName !== void 0 ? _reference$pageName : "/",
      key: id
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
  }
};
const ReferenceButtons = props => {
  const {
    data
  } = props;
  const {
    elements,
    title
  } = data;
  const css = useStyles();
  if (!elements) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: title,
    component: "h2"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: css.root,
    mb: 4,
    mt: 4
  }, elements.map(item => /*#__PURE__*/_react.default.createElement(DetectLink, _extends({
    key: item === null || item === void 0 ? void 0 : item.id
  }, item)))));
};
var _default = exports.default = ReferenceButtons;